import * as ui from "../../app/core/ui";

var view = (type: string) => {
    let firstFilterComponents: ui.Component[] = [];

    if (type === "Date" || type === "DateTime") {
        firstFilterComponents.push(
            new ui.PresetDateRangeDropDownList({
                id: "PresetDateRanges",
                bsc: "col-xs-12 no-pad"
            })
        );
    }

    firstFilterComponents.push(
        new ui.DropDownList({
            id: "FirstExpression",
            bindValue: "FirstExpression",
            dataValueField: "Value",
            dataTextField: "Text",
            bsc: "col-xs-12 no-pad expression",
            valueWidth: 160
        })
    );

    let secondFilterComponents: ui.Component[] = [
        new ui.DropDownList({
            id: "SecondExpression",
            bindValue: "SecondExpression",
            template: "#= data.Text #",
            dataValueField: "Value",
            dataTextField: "Text",
            bsc: "col-xs-12 no-pad expression",
            valueWidth: 160
        })
    ];

    if (type === "DateTime") {
        firstFilterComponents.push(
            new ui.DateTimeInput({
                id: "StartDateTime",
                bindValue: "StartDateTime",
                bsc: "col-xs-12 no-pad first-value",
                containerClasses: " ",
                valueWidth: 180
            })
        );
        secondFilterComponents.push(
            new ui.DateTimeInput({
                id: "EndDateTime",
                bindValue: "EndDateTime",
                bsc: "col-xs-12 no-pad second-value",
                valueWidth: 180
            })
        );
    }

    if (type === "Date") {
        firstFilterComponents.push(
            new ui.DateInput({
                id: "StartDate",
                bindValue: "StartDate",
                bsc: "col-xs-12 no-pad first-value"
            })
        );
        secondFilterComponents.push(
            new ui.DateInput({
                id: "EndDate",
                bindValue: "EndDate",
                bsc: "col-xs-12 no-pad second-value"
            })
        );
    }

    if (type === "OffsetTime") {
        firstFilterComponents.push(
            new ui.TimeInput({
                id: "OffsetStartTime",
                bindValue: "OffsetStartTime",
                bsc: "col-xs-12 no-pad first-value"
            })
        );
        secondFilterComponents.push(
            new ui.TimeInput({
                id: "OffsetEndTime",
                bindValue: "OffsetEndTime",
                bsc: "col-xs-12 no-pad second-value"
            })
        );
    }

    if (type === "TimeOfDay") {
        firstFilterComponents.push(
            new ui.TimeInput({
                id: "TimeOfDayStartTime",
                bindValue: "TimeOfDayStartTime",
                bsc: "col-xs-12 no-pad first-value",
                useAbsoluteTime: true
            })
        );
        secondFilterComponents.push(
            new ui.TimeInput({
                id: "TimeOfDayEndTime",
                bindValue: "TimeOfDayEndTime",
                bsc: "col-xs-12 no-pad second-value",
                useAbsoluteTime: true
            })
        );
    }

    if (type === "Code" || type === "UDFEnum") {
        firstFilterComponents.push(
            new ui.ComboBox({
                id: "FirstCode",
                bindValue: "FirstCode",
                labelField: "CodeNumber",
                valueField: "Id",
                bsc: "col-xs-12 no-pad first-value",
                systemCode: true,
                containerClasses: " "
            }),
            new ui.TextBox({
                id: "FirstCodeText",
                bindValue: "FirstCodeText",
                labelField: "CodeNumber",
                valueField: "Id",
                bsc: "col-xs-12 no-pad-l-r no-pad-b mar-t-2 first-value",
                containerClasses: " "
            })
        );
        secondFilterComponents.push(
            new ui.ComboBox({
                id: "SecondCode",
                bindValue: "SecondCode",
                labelField: "CodeNumber",
                valueField: "Id",
                bsc: "col-xs-12 no-pad second-value",
                systemCode: true
            }),
            new ui.TextBox({
                id: "SecondCodeText",
                bindValue: "SecondCodeText",
                labelField: "CodeNumber",
                valueField: "Id",
                bsc: "col-xs-12 no-pad-l-r no-pad-b mar-t-2 second-value",
                containerClasses: " "
            })
        );
    }

    if (
        type === "Int32" ||
        type === "Int16" ||
        type === "Byte" ||
        type === "Currency" ||
        type === "Decimal" ||
        type === "Single"
    ) {
        let parameters;

        switch (type) {
            case "Int32":
            case "Int16":
            case "Byte":
                parameters = {
                    decimals: 0,
                    format: "n0"
                };
                break;
            case "Currency":
                parameters = {
                    decimals: null,
                    format: "c"
                };
                break;
            case "Decimal":
            case "Single":
            default:
                parameters = {
                    decimals: 10,
                    format: "#.##########"
                };
        }

        firstFilterComponents.push(
            new ui.NumericInput({
                id: "FirstNumber",
                bindValue: "FirstNumber",
                bsc: "col-xs-12 no-pad first-value",
                ...parameters
            })
        );
        secondFilterComponents.push(
            new ui.NumericInput({
                id: "SecondNumber",
                bindValue: "SecondNumber",
                bsc: "col-xs-12 no-pad second-value",
                ...parameters
            })
        );
    }

    if (type === "Custom") {
        firstFilterComponents.push(
            new ui.ComboBox({
                id: "FirstCustom",
                bindValue: "FirstCustom",
                labelField: "Text",
                valueField: "Value",
                bsc: "col-xs-12 no-pad first-value",
                containerClasses: " "
            }),
            new ui.TextBox({
                id: "FirstCustomText",
                bindValue: "FirstCustomText",
                labelField: "Text",
                valueField: "Value",
                bsc: "col-xs-12 no-pad-l-r no-pad-b mar-t-2 first-value",
                containerClasses: " "
            })
        );
        secondFilterComponents.push(
            new ui.ComboBox({
                id: "SecondCustom",
                bindValue: "SecondCustom",
                labelField: "Text",
                valueField: "Value",
                bsc: "col-xs-12 no-pad first-value",
                containerClasses: " "
            }),
            new ui.TextBox({
                id: "SecondCustomText",
                bindValue: "SecondCustomText",
                labelField: "Text",
                valueField: "Value",
                bsc: "col-xs-12 no-pad-l-r no-pad-b mar-t-2 first-value",
                containerClasses: " "
            })
        );
    }

    let filters = [];

    if (type === "Boolean") {
        filters = firstFilterComponents;
    } else {
        filters = [
            ...firstFilterComponents,
            new ui.DropDownList({
                id: "Operator",
                bindValue: "Operator",
                template: "#= data.Text #",
                dataValueField: "Value",
                dataTextField: "Text",
                bsc: "col-xs-12",
                valueWidth: 60,
                containerClasses:
                    "mar-l-0 mar-r-0 pad-l-0 pad-r-0 mar-b-5 mar-t-5"
            }),
            ...secondFilterComponents
        ];
    }

    return new ui.Container({
        components: [
            new ui.Container({
                bsc: "col-xs-12 pad-l-0 pad-r-0 pad-b-5",
                components: [
                    new ui.HTML({
                        HTML: "<div id='FilterResults' ></div>"
                    })
                ]
            }),
            ...filters,
            new ui.Container({
                bsc: "col-xs-12 pad-l-0 pad-r-0 mar-b-5",
                components: [
                    new ui.HTML({
                        HTML: "<button type='submit' id='ApplyFilter' class='k-button k-primary'>Apply filter</button>"
                    }),
                    new ui.HTML({
                        HTML: "<button type='submit' id='ClearFilter' class='k-button'>Clear filter</button>"
                    })
                ]
            })
        ]
    });
};

export default view;
